import 'css-chunksrc/client/scenes/moveDocument/folderSelection/folder/logo/styles.scss';export default {
  "logo": "_logo_18vkm_1"
};